
(function () {
  'use strict';

  function init() {
    const mains = document.querySelectorAll('main');
    for (const main of mains) {
      const accordions = main.querySelectorAll('.accordion.accordion--dividers');
      if (accordions.length < 2) continue;

      let isFaq = false;
      accordions.forEach((acc) => {
        let walker = acc;
        while (walker && walker !== main) {
          const sib = walker.previousElementSibling;
          if (sib && sib.querySelector && sib.querySelector('h2')) {
            isFaq = true;
            break;
          }
          walker = walker.parentElement;
        }
      });
      if (!isFaq) continue;

      main.classList.add('faq-enhanced');

      // Tag each section's accordion so CSS counters reset per-section
      accordions.forEach((acc, idx) => {
        acc.classList.add('faq-accordion');
        acc.dataset.faqSection = String(idx + 1).padStart(2, '0');
      });
      break;
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
